import React from 'react';
import styled from 'styled-components';
import { CenterBox, Icons } from '@docon/docon-ui-library';

interface IProps {
  [key: string]: any;
  height?: string;
  width?: string;
  iconSize?: number;
}

const Root = styled(CenterBox)`
  height: ${(props: any) => props.$height || '100%'};
  width: ${(props: any) => props.$width || '100%'};
`;

function Loader({
  height,
  width,
  iconSize = 30,
  ...props
}: IProps) {

  return (
    <Root p={20} $height={height} $width={width}
      {...props}>
      <Icons.LoadingIcon width={iconSize} />
    </Root>
  );
}
export default styled(Loader)``;